import React from "react";
import "./HouseingTransform.css";

const GuestHouseTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Elevate Your Guest House Standards
        </h2>

        <p className="workplace-cta-text">
          Get professional management for your corporate guest house with
          hospitality-trained staff and hotel-like service standards
        </p>

        <a
          href="https://wa.me/919899811123?text=Guest%20House%20Management"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Manage Our Guest House →
        </a>
      </div>
    </section>
  );
};

export default GuestHouseTransform;
